module.exports = __webpack_public_path__ + "static/images/wechatCode.a66c7f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechatCode.jpg
// module id = EftG
// module chunks = 0